module.exports = __webpack_public_path__ + "img/th.ae32c146.png";